import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { useAppEventBusContext } from '@/context/eventBusContext';
import { SubscribeEvent } from '@/interface/event';
import { useDynamicHeight } from '@/hooks/base/useDynamicHeight';
import { useAppStore } from '@/store';

export default () => {
  const { fwClass } = useAppStore();
  const { publish } = useAppEventBusContext();
  const { t } = useTranslation();
  const height = useDynamicHeight({ customHeight: 70 });
  return (
    <div className="px-[16px] flex  items-center" style={{ height: height + 'px' }}>
      <div className="flex justify-center w-full">
        <div className="flex flex-col gap-y-[62px]">
          <img src="/icon/Login-image.png" className="w-full h-[210px]" />
          <Button
            className="w-full !bg-themeColor rounded-[12px] h-[48px] text-primaryTextColor"
            onClick={() => publish(SubscribeEvent.Open_Wallet_Modal, true)}
          >
            <span className={fwClass}>{t('Base.login')}</span>
          </Button>
        </div>
      </div>
    </div>
  );
};
